/**
 * @prettier
 */
export const OrderTags = {
    NEW_CLIENT: 'NEW_CLIENT',
    QUICK_ACTION: 'QUICK_ACTION',
} as const;

export type OrderTag = typeof OrderTags[keyof typeof OrderTags];
